import { RelatedItems } from '@interfaces/config';
import { CmsComponentTypeEnum } from '@models/enums';

export namespace RelatedSolutions {
  export const TypeEnum = CmsComponentTypeEnum.RELATED_SOLUTIONS;

  export interface ComponentConfig extends RelatedItems.ComponentConfig {}
}
